import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import StatechartAppVue from "../components/App/StatechartApp.vue";
import MaintenanceComponentVue from "../components/Maintenance/MaintenanceComponent.vue";
import AuthComponentVue from "../components/Authentication/AuthComponent.vue";
import OidcCallbackView from "../components/Authentication/OidcCallbackView.vue";
import { authStore } from "../stores/authStore";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";

const routes: RouteRecordRaw[] = [
  {
    path: "/home",
    name: "Home",
    component: StatechartAppVue,
  },
  {
    path: "/login",
    name: "Login",
    component: AuthComponentVue,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/logout-succeeded",
    redirect: "/login",
  },
  {
    path: "/logout-succeeded-vscode",
    redirect: { path: "/login", query: { source: "vscode" } },
  },
  {
    path: "/callback",
    name: "oidcCallback",
    component: OidcCallbackView,
  },
  {
    path: "/maintenance",
    name: "MaintenanceComponentVue",
    component: MaintenanceComponentVue,
  },
  {
    path: "/:notFound(.*)",
    redirect: "/home",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from) => {
  // cannot inject here the localStorage instance, so accessing it manually with the current default storage prefix sct_ to the storage param
  if (window.localStorage) {
    if (from.path !== "/callback" && to.path !== "/callback") {
      localStorage.setItem("sct_queryParams", new URLSearchParams(window.location.search).toString());
    }
  }
});
router.beforeEach(vuexOidcCreateRouterMiddleware(authStore));

export default router;
